import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar';
import Banner from './components/Banner';
import Services from './components/Services';
import InfoSections from './components/InfoSections';
import JobApplicationPage from './components/JobApplicationPage';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsAndConditions from './components/TermsAndConditions';
import ScrollToTop from './components/ScrollToTop';
import FAQs from './components/FAQs';
import NotFound from './components/NotFound';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import MobileCallBar from './components/common/MobileCallBar';
import FeaturedServiceLinks from './components/common/FeaturedServiceLinks';
import AboutUs from './components/AboutUs';
import ServicesPage from './components/ServicesPage';
import ContactPage from './components/ContactPage';
import TestimoniosPage from './components/TestimoniosPage';
import CostCalculator from './components/CostCalculator';

// Service Landing Pages
import {
  Enfermeria24Horas,
  CuidadosGeriatricos,
  AtencionPostoperatoria,
  EnfermeriaZapopan,
  EnfermeriaTlaquepaque,
  ServiciosExpres
} from './components/service-pages';

// Blog
import { BlogPage, BlogPost } from './components/blog';

import { SpeedInsights } from "@vercel/speed-insights/react";
import { Analytics } from "@vercel/analytics/react";

function App() {
  return (
    <Router>
      <SpeedInsights />
      <Analytics />
      <ScrollToTop />
      <div className="App pb-14 lg:pb-0">
        <Navbar />
          <Routes>
            <Route path="/" element={
              <>
                <Banner />
                <Services />
                <InfoSections />
                <FeaturedServiceLinks />
                <FAQs />
              </>
            } />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/faqs" element={<FAQs standalone />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/careers" element={<JobApplicationPage />} />
            <Route path="/JobApplicationPage" element={<JobApplicationPage />} /> {/* Legacy redirect */}
            
            {/* Testimonios y Calculadora */}
            <Route path="/testimonios" element={<TestimoniosPage />} />
            <Route path="/calculadora-costos" element={<CostCalculator />} />
            
            {/* Service Landing Pages */}
            <Route path="/enfermeria-24-horas" element={<Enfermeria24Horas />} />
            <Route path="/cuidados-geriatricos" element={<CuidadosGeriatricos />} />
            <Route path="/atencion-postoperatoria" element={<AtencionPostoperatoria />} />
            <Route path="/enfermeria-zapopan" element={<EnfermeriaZapopan />} />
            <Route path="/enfermeria-tlaquepaque" element={<EnfermeriaTlaquepaque />} />
            <Route path="/servicios-expres" element={<ServiciosExpres />} />
            
            {/* Blog */}
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
          <CookieConsent />
          <MobileCallBar />
        </div>
    </Router>
  );
}

export default App;